import { render, staticRenderFns } from "./relatorioSaldoDevedor.vue?vue&type=template&id=0a08b921"
import script from "./relatorioSaldoDevedor.vue?vue&type=script&lang=js"
export * from "./relatorioSaldoDevedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports